export const ADDRESS_ERROR_MESSAGE = 'Please select an address from the dropdown'
export const API_SEARCH_URL = '/address/autocomplete/'
export const DEFAULT_ERROR = 'There was an error finding your address'
export const SWITCH_MANUAL_ADDRESS = 'cantfind'
export const ITEM_MONIKER_TOO_SHORT = 'tooshort'
export const ITEM_MONIKER_TOO_MANY = 'toomany'
export const TOO_MANY_ERROR_STATUS = 'TooManyMatches'
export const HAS_RESULTS_STATUS = 'PickList'
export const NO_MATCHES_STATUS = 'NoMatches'
export const ADDRESS_ID_KEY = 'address'
export const ADDRESS_TEXT_KEY = 'addressText'

// How many characters before we start checking for results
export const AUTOCOMPLETE_MIN_CHARS = 3



// WEBPACK FOOTER //
// ./components/AutocompleteAddress/constants.js